import { render } from "./legoTreeTable.vue?vue&type=template&id=088472c8"
import script from "./legoTreeTable.vue?vue&type=script&lang=js"
export * from "./legoTreeTable.vue?vue&type=script&lang=js"

import "./legoTreeTable.vue?vue&type=style&index=0&id=088472c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/extend/legoTreeTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "088472c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('088472c8', __exports__)) {
    api.reload('088472c8', __exports__)
  }
  
  module.hot.accept("./legoTreeTable.vue?vue&type=template&id=088472c8", () => {
    api.rerender('088472c8', render)
  })

}


export default __exports__